import { render } from "./crm-form.vue?vue&type=template&id=09f9be7f&scoped=true"
import script from "./crm-form.vue?vue&type=script&lang=js"
export * from "./crm-form.vue?vue&type=script&lang=js"

import "./crm-form.vue?vue&type=style&index=0&id=09f9be7f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f9be7f"]])

export default __exports__